<div class="main-modal">
  <div class="modal-header">
    <h3 class="modal-title">Ping IRS Server</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times"></i>
    </div>
  </div>
  <div class="modal-body" [hidden]="minimise">
    <div class="options">
      <label>
        <input type="radio" value="TEST" [(ngModel)]="envType"> TEST
      </label>
      <label>
        <input type="radio" value="PRODUCTION" [(ngModel)]="envType"> PRODUCTION
      </label>
    </div>
  </div>
  <div class="modal-footer" [hidden]="minimise">
    <button class="save-button" type="button" [disabled]="pinging" (click)="pingToIRS()">
      @if (pinging) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Ping
    </button>
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
